import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import MindMathComp  from "./Component/MindMathComp"

const MindMath =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <MindMathComp />
        </div>
        <Footer />
        </>
    )
}

export default MindMath